<template>
  <div class="footer">
    <div class="footer__content">
      <div class="footer__items">
        <div class="footer__items-top">
          <div class="container">
            <div class="footer__items-top-logo">
              <img src="@/assets/images/svg/MainLogo.svg" alt="" />
            </div>
            <div class="footer__items-top-route">
              <ul>
                <li v-for="(item, idx) in navLink" :key="idx">
                  <a @click="toPage(item)" class="f-16">{{
                    item.name
                  }}</a>
                </li>
              </ul>
            </div>
            <div class="footer__items-top-social">
              <a v-for="(item, idx) in social" :key="'s' + idx"
                ><img :src="item.icon" alt=""
              /></a>
            </div>
          </div>
        </div>
        <div class="footer__items-bottom">
          <div class="container">
            <div class="footer__items-bottom-left">
              <a class="f-16">© 2023 "MalMarket"</a>
              <p class="f-16">Все права защищены</p>
            </div>
          
            <div class="footer__items-bottom-right">
            <a class="f-16" v-for="(item , idx) in docs2" :key="'d2'+ idx">{{ item.title }}</a>
            </div>
          </div>
        </div>
        <div class="footer__items-links">
            <div class="container">
              <a v-for="(item,idx) in docs" :key="'d' + idx"
                ><span><svg
                  width="12"
                  height="16"
                  viewBox="0 0 12 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2 0C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H10C11.1046 16 12 15.1046 12 14V5.41421C12 4.88378 11.7893 4.37507 11.4142 4L8 0.58579C7.6249 0.21071 7.1162 0 6.5858 0H2ZM7 6C7 5.44772 6.5523 5 6 5C5.44772 5 5 5.44772 5 6V9.5858L3.70711 8.2929C3.31658 7.90237 2.68342 7.90237 2.29289 8.2929C1.90237 8.6834 1.90237 9.3166 2.29289 9.7071L5.29289 12.7071C5.68342 13.0976 6.3166 13.0976 6.7071 12.7071L9.7071 9.7071C10.0976 9.3166 10.0976 8.6834 9.7071 8.2929C9.3166 7.90237 8.6834 7.90237 8.2929 8.2929L7 9.5858V6Z"
                    fill="#454545"
                  />
                </svg></span><p class="f-16">{{item.title}}</p>
              </a>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    navLink: [
      {
        name: "Объявления",
        route: "Catalog",
        slug: ""
      },
      {
        name: "Новости",
        route: "News",
        slug: ""
      },
      {
        name: "Продвижение",
        route: "Promotion",
        slug: ""
      },
      {
        name: "Организации",
        route: "Organization",
         slug: ""
      },
      {
        name: "Услуги",
        route: "CategoryBySlug",
        slug: "uslugi"
      },
      // {
      //   name: "Форумы",
      //   route: "News",
      // },
    ],
    social: [
      {
        icon: require("@/assets/images/svg/whatsapp.svg"),
        href: "",
        blanc: "",
      },
      {
        icon: require("@/assets/images/svg/telegram.svg"),
        href: "",
        blanc: "",
      },
      {
        icon: require("@/assets/images/svg/vk.svg"),
        href: "",
        blanc: "",
      },
      {
        icon: require("@/assets/images/svg/instagram.svg"),
        href: "",
        blanc: "",
      },
      {
        icon: require("@/assets/images/svg/youtube.svg"),
        href: "",
        blanc: "",
      },
    ],
    docs: [
        {
            title: 'Пользовательское соглашение',
            href: ''
        },
        {
            title: 'Политика конфиденциальности',
            href: ''
        },
        {
            title: 'Правила размещения обьявления',
            href: ''
        },
        {
            title: 'Правила оплаты',
            href: ''
        },
        {
            title: 'Оферта',
            href: ''
        },
    ],
    docs2: [
        {
            title: 'По вопросам рекламы: info@MalMarket.kz  ',
            href : ''
        },
    ]
  }),
  methods: {
    toPage(value){
      if(value.route == 'CategoryBySlug'){
        console.log('111');
        this.$router.push({ name: value.route, params: { slug : value.slug }})
      } else {
        console.log('222');
        this.$router.push({ name: value.route})
      }
    }
  }
};
</script>

<style></style>
